import { FETCH_DATA_GETCATEGORYLIST2_CAT } from "../ActionType/actionTypes";
import axios from "axios";
import base64Sign from "../../function/base64Sign";
import encryptData from "../../function/encryptData";
import { getToken } from "../../utils/setSessionUser";
import {BaseURL} from '../../function/helpers'
import { isLoadingGetCatList2 } from "./Loading/isLoadingGetCatList2Actions";

export const fetchGetCategoryList2 = (params, url) => {
    return( dispatch ) => {
        const param = encryptData(params)
        const signature = base64Sign(url);
        const access_token = getToken()
        const headers = 
        {
        'Content-Type':'application/json',
        'sign' : signature,
        'access_token' : access_token
        }
        axios.post(BaseURL + url,
            {data: param},
            {headers : headers}
        )
            .then( data => {
                dispatch({
                    type: FETCH_DATA_GETCATEGORYLIST2_CAT,
                    payload: {
                        getCategoryList2: data.data.response_data.results
                    }
                })
                dispatch(isLoadingGetCatList2(false))
            } )
            .catch(error => {
                console.log(error);
            })
    }
}